<template>
  <avtalat-modal
    :closeOnClickOutside="true"
    :closeOnEsc="true"
    :closeFn="closeManualVerificationModal"
    :idealHeight="1125"
  >
    <div>
      <span class="type-heading-md" id="manuell-identifiering-modal"
        >Manuell identifiering</span
      >
      <button
        class="absolute right-md top-md p-sm"
        @click="closeManualVerificationModal"
      >
        <avtalat-icon class="text-black" id="kryss-enkelt" :size="15" />
      </button>
      <VerificationQuestion
        class="mt-md"
        id="fraga-1"
        questionNumber="1"
        questionText="Vad heter du?"
        :questionAnswer="individ?.fornamn + ' ' + individ?.efternamn"
      />
      <hr class="mt-sm" />
      <VerificationQuestion
        class="mt-md"
        id="fraga-2"
        questionNumber="2"
        questionText="Vad har du för personnummer?"
        :questionAnswer="
          personnummerWithDash12Digits(individ?.personnummer) ?? ''
        "
      />
      <hr class="mt-sm" />
      <VerificationQuestion
        class="mt-md"
        id="fraga-3"
        questionNumber="3"
        questionText="Vad är din nuvarande adress?"
        :questionAnswer="
          hasAddressInformation(individ?.adress)
            ? (individ?.adress?.gatuadress
                ? individ?.adress?.gatuadress
                : 'Ingen uppgift') +
              ', ' +
              (individ?.adress?.postnummer?.length === 5
                ? formatPostnummer(individ?.adress?.postnummer)
                : 'Ingen uppgift') +
              ', ' +
              (individ?.adress?.postort
                ? individ?.adress?.postort
                : 'Ingen uppgift')
            : 'Ingen adressuppgift tillgänglig i Kundserviceappen. Se Admyra (Företag/Försäkrad > Adresser) för manuell adress'
        "
      />
      <hr class="mt-sm" />
      <VerificationQuestion
        class="mt-md"
        id="fraga-4"
        questionNumber="4"
        questionText="Vad heter din senaste arbetsgivare med ITP?"
        :questionAnswer="
          latestArbetsGivareWithItp
            ? latestArbetsGivareWithItp.arbetsgivareNamn
            : 'Det finns ingen tidigare arbetsgivare med ITP'
        "
      />
      <hr class="mt-sm" />
      <div class="mt-md">
        <div>
          <div class="type-heading-sm mt-xs" id="fraga-5">Fråga 5</div>
          <div>När var du anställd hos denna arbetsgivare?</div>
          <div class="type-heading-sm mt-xs">Svar</div>
          <div
            v-for="(arbetsgivare, index) in anstalldStore.basuppgifter.data
              ?.basuppgifterList"
            :key="index"
          >
            <div>
              {{ arbetsgivare.arbetsgivareNamn }}:
              {{ `${arbetsgivare.startdatum}` }} -
              {{ `${arbetsgivare.slutdatum}` }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-end" id="manuellt-identifierad-button">
        <avtalat-button class="mt-xl" @click="verifyPersonAndCloseModal"
          >Identifierad</avtalat-button
        >
        <avtalat-button
          class="ml-sm shrink self-end text-base"
          id="cancel-manuellt-identifierad-button"
          @click="closeManualVerificationModal"
          outlined
          >Avbryt</avtalat-button
        >
      </div>
    </div>
  </avtalat-modal>
</template>
<script setup lang="ts">
import type { Adress } from "@/composables/KundserviceAppApiClient";
import { useIndividStore } from "@/stores";
import {
  formatPostnummer,
  personnummerWithDash12Digits,
} from "@/common/formatters";
import { useAnstalldStore } from "@/views/anstalld/store";

import VerificationQuestion from "./VerificationQuestion.vue";

const individStore = useIndividStore();
const individ = individStore?.individ?.data;
const anstalldStore = useAnstalldStore();
const latestArbetsGivareWithItp =
  anstalldStore.basuppgifter.data?.basuppgifterList?.find(
    (x) => x.pensionsplansnamn != null && x.pensionsplansnamn != "",
  );

const closeManualVerificationModal = () => {
  individStore.verification.showManualVerification = false;
};
const verifyPersonAndCloseModal = () => {
  individStore.verification.showManualVerification = false;
  individStore.verification.isManuallyVerified = true;
};

const hasAddressInformation = (adress: Adress | null | undefined) => {
  return adress?.gatuadress || adress?.postnummer || adress?.postort;
};
</script>
